import { AccountGotoAction } from '../account-router';
import { TermsType } from './model/terms-update';

export class ShowUpdatedTermsNotification {
  static readonly type = '[UpdatedTerms] Show updated terms notification';
}

export class ConfirmUpdatedTerms {
  static readonly type = '[UpdatedTerms] Confirm updated terms';
  constructor(public types: TermsType[]) {}
}

export class GotoNewTerms extends AccountGotoAction {
  static readonly type = '[UpdatedTerms] Goto new terms';
}
